<template>
    <div
        class="ag-cell-label-container"
        :class="classes"
        role="presentation"
        :title="columnHeaderText"
    >
        <div
            ref="eLabel"
            class="ag-header-cell-label"
            role="presentation"
        >
            <span
                v-if="displayName"
                ref="eText"
                class="ag-header-cell-text"
                role="columnheader"
            >
                {{ columnHeaderText }}

                <TooltipHelp
                    v-if="tooltiptext"
                    :text="tooltiptext"
                ></TooltipHelp>
            </span>
            <slot></slot>
        </div>
    </div>
</template>

<script setup lang="ts" generic="TRowData, TCell = any">
import { TooltipHelp } from '@/components';
import type { IGridCompExposed } from '../Classes';
import type { IHeaderComponentParamsColumn } from '../Classes/params/IHeaderComponentParamsColumn';
import { computed } from 'vue';
import { $tm } from '@/locize';

const props = defineProps<{
    grid: IGridCompExposed<TRowData>;
    column: IHeaderComponentParamsColumn;
    displayName?: string;
    /**
     * If we want to show a tooltiptext hint in the header
     * This one is defined in the headerProps of the column def
     */
    tooltiptext?: string;
    /**
     * The classes to apply to the header
     */
    classes?: string;
}>();

const columnHeaderText = computed(() => {
    if (!props.displayName) {
        return '';
    }
    return $tm(props.displayName);
});
</script>
